export class User {
  name: string;
  password: string;
  email: string;
  mobile: number;
  role: number;
  userId: string;
  userType: number;
  opType: number;
  feature?: UserFeature[];
  id?: number;
  isDeleted?: boolean;
  isAdmin?: boolean;
  isUser?: boolean;
  isSuperAdmin?: boolean;
  isBlocked?: boolean;
  departmentName?: string;
  regionName?: string;
  roleName?: string;
  department?: number;
  region?: number;
}

export class UserFeature {
  fName: string;
}
